<script>
  import {createEventDispatcher} from 'svelte';
  import Modal from '@/widgets/Modal.svelte';
  import Button from '@/widgets/Button.svelte';
  import lang from './NoticeDialog.lang';

  export let LG = null;

  const dispatch = createEventDispatcher();

  function handleCloseClick() {
    dispatch('close');
  }

  function handleClickStop(e) {
    e.stopPropagation();
  }

  function handleConfirmClick() {
    handleCloseClick();
  }
</script>

<div class="dialog-box" on:mousewheel|preventDefault>
  <Modal visible allowScroll on:close={handleCloseClick} style="border-radius: 12px;width: 480px;background: #fff;">
    <div class="header df aic jcc lh24 f24" slot="header">
      <div class="lh24 f20 fw3 T1">{LG(lang.Notice)}</div>
    </div>
    <div class="df fdc aic mt40" on:click={handleClickStop}>
      <div class="df fdc">
        <div class="lh24 f16 T1">{LG(lang.SorryThisService)}</div>
        <div class="lh24 f16 T1">{LG(lang.IfYouWantTo)}</div>
      </div>
      <div class="mt40 wp100">
        <Button class="wp100" newRadius type="primary" on:click={handleConfirmClick}>{LG(lang.Confirm)}</Button>
      </div>
    </div>
  </Modal>
</div>
